import { render, staticRenderFns } from "./ProposalItemHolder.vue?vue&type=template&id=e84254f6&scoped=true"
import script from "./ProposalItemHolder.vue?vue&type=script&lang=js"
export * from "./ProposalItemHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84254f6",
  null
  
)

export default component.exports